import { render, staticRenderFns } from "./DialogBooking.vue?vue&type=template&id=23348fe3&"
import script from "./DialogBooking.vue?vue&type=script&lang=js&"
export * from "./DialogBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports